module.exports = __webpack_public_path__ + "img/device-frame.cdae33e.png";